import Preloader from './sections/Preloader'
import Navbar from './sections/Navbar'
import Hero from './sections/Hero'
import Benefits from './sections/Benefits'
import Modules from './sections/Modules'
import LeadForm from './sections/LeadForm'
import Trust from './sections/Trust'
import Footer from './sections/Footer'
import FloatingCTA from './sections/FloatingCTA'

function App() {
  return (
    <div className="relative overflow-x-hidden">
      <Preloader />
      <Navbar />
      <main>
        <Hero />
        <Benefits />
        <Modules />
        <Trust />
        <LeadForm />
      </main>
      <Footer />
      {/* <FloatingCTA /> */}
    </div>
  )
}

export default App
